export default __webpack_public_path__ + "static/media/Sarah Williams.9d61de66.jpg";